import { render, staticRenderFns } from "./return-good-modal.vue?vue&type=template&id=792029cc&"
import script from "./return-good-modal.vue?vue&type=script&lang=js&"
export * from "./return-good-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports